import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';

const IconX = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);

const IconArrow = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
);

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();
  const { language, setLanguage } = useLanguage();

  const closeMenu = () => setIsOpen(false);

  const menuItems = [
    { name: language === 'PL' ? 'START' : 'HOME', href: '/' },
    { name: language === 'PL' ? 'O NAS' : 'ABOUT', href: '/o-nas' },
    { name: language === 'PL' ? 'PORTFOLIO' : 'WORK', href: '/portfolio' },
    { name: language === 'PL' ? 'OFERTA' : 'OFFER', href: '/oferta' },
    { name: language === 'PL' ? 'PORADNIK' : 'GUIDE', href: '/blog' },
    { name: language === 'PL' ? 'KONTAKT' : 'CONTACT', href: '/kontakt' },
  ];

  return (
    <nav className="fixed top-4 sm:top-6 left-0 w-full z-[9999] flex justify-center items-start px-3 sm:px-4 pointer-events-none navbar-wrapper">
      <div 
        className={`bg-[#050505]/95 backdrop-blur-2xl border border-white/10 overflow-hidden rounded-[24px] sm:rounded-[32px] w-full pointer-events-auto transition-all duration-500 ease-[cubic-bezier(0.25,1,0.5,1)] flex flex-col ${isOpen ? 'max-h-[800px]' : 'max-h-[64px]'}`}
        style={{ maxWidth: isMobile ? '100%' : '800px' }}
      >
        <div className="h-[64px] min-h-[64px] flex items-center justify-between px-5 sm:px-8 w-full">
          <Link to="/" onClick={closeMenu}>
            <img src="/logosolidagency.webp" alt="Logo Solid Agency" width="68" height="70" className="h-6 sm:h-7 w-auto" />
          </Link>
            <div className="flex items-center gap-3 sm:gap-4 font-syne font-bold">
            <div className="flex bg-white/5 rounded-full p-1 border border-white/10">
              <button onClick={() => setLanguage('PL')} aria-label="Zmień na PL" className={`w-8 sm:w-10 py-1 sm:py-1.5 rounded-full text-[8px] sm:text-[9px] text-center transition-colors ${language === 'PL' ? 'bg-white text-black' : 'text-white/40'}`}>PL</button>
              <button onClick={() => setLanguage('ENG')} aria-label="Change to EN" className={`w-8 sm:w-10 py-1 sm:py-1.5 rounded-full text-[8px] sm:text-[9px] text-center transition-colors ${language === 'ENG' ? 'bg-white text-black' : 'text-white/40'}`}>EN</button>
            </div>
            {!isMobile && <Link to="/kontakt" className="text-[9px] tracking-widest uppercase text-white font-syne font-bold">KONTAKT</Link>}
            <button onClick={() => setIsOpen(!isOpen)} aria-label="Menu" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white">
              {isOpen ? <IconX /> : <div className="space-y-1.5"><div className="w-5 h-0.5 bg-white"></div><div className="w-5 h-0.5 bg-white"></div></div>}
            </button>
          </div>
        </div>

        <div className={`px-5 sm:px-10 transition-opacity duration-500 delay-100 ${isOpen ? 'opacity-100 pb-8 sm:pb-12 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
          <div className={`flex flex-col gap-1 sm:gap-2 mt-6 sm:mt-8 transition-transform duration-500 ease-[cubic-bezier(0.25,1,0.5,1)] ${isOpen ? 'translate-y-0' : '-translate-y-4'}`}>
            {menuItems.map((item) => (
              <Link key={item.name} to={item.href} onClick={closeMenu} className="flex justify-between items-center text-[2rem] sm:text-5xl font-syne font-bold text-white hover:text-[#cbc7e3] tracking-tighter transition-colors leading-[1.1]">
                {item.name} <IconArrow />
              </Link>
            ))}
          </div>
          <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 mt-10 sm:mt-14 transition-transform duration-500 delay-100 ease-[cubic-bezier(0.25,1,0.5,1)] ${isOpen ? 'translate-y-0' : '-translate-y-4'}`}>
            <Link to="/zacznij-projekt" onClick={closeMenu} className="bg-[#cbc7e3] p-6 sm:p-8 rounded-[1.8rem] sm:rounded-[2.5rem] flex items-center justify-between group">
              <span className="text-center text-[27px] leading-[22px] sm:text-[40px] sm:leading-8 font-syne font-bold text-black uppercase not-italic">{language === 'PL' ? <>ZACZNIJ<br className="hidden sm:block"/> PROJEKT</> : <>START<br className="hidden sm:block"/> PROJECT</>}</span>
              <img src="/rakieta.webp" alt="" width="80" height="80" className="h-12 sm:h-20 w-auto object-contain" />
            </Link>
            <Link to="/kontakt" onClick={closeMenu} className="bg-white p-6 sm:p-8 rounded-[1.8rem] sm:rounded-[2.5rem] flex items-center justify-between group">
              <span className="text-center text-[27px] leading-[22px] sm:text-[40px] sm:leading-8 font-syne font-bold text-black uppercase not-italic">{language === 'PL' ? <>ODEZWIJ<br className="hidden sm:block"/> SIĘ</> : <>SAY<br className="hidden sm:block"/> HELLO</>}</span>
              <img src="/telefon getintouch.webp" alt="" width="80" height="80" className="h-12 sm:h-20 w-auto object-contain" />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
